import { createFileRoute } from '@tanstack/react-router'

import { SyncView } from '@/components/Internal/Development/SyncView'

export const Route = createFileRoute('/internal/system/development/sync')({
  component: SyncView,
})
